import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { bodyBusquedaTicket, ConfigInitial } from '../models';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  readonly header: HttpHeaders;
  constructor(
    private http: HttpClient
  ) {
    this.header = new HttpHeaders({
      "Content-Type": "application/json",
      "Api-Key": environment.apk
    });
  }

  public getConfiguration(id: string): Observable<ConfigInitial> {
    return this.http.get<ConfigInitial>(`${environment.api_configuracion}/configuration/${id}`);
  };

  public getMensajePersonalizado(rfc_emisor: string, codigo: string): Observable<any> {
    return this.http.get<any>(`${environment.api_mensajes_personalizados}/stage/api/v1/mensajePersonalizado/${rfc_emisor}/${codigo}`, { headers: this.header });
  }

  public buscarConfiguracionTicket(body: bodyBusquedaTicket): Observable<string> {
    return this.http.post(`${environment.api_busqueda_configuracion}`, body, { headers: this.header, responseType: 'text' });
  }
}
